import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../colorVars';
import Candle from './newCandleChart/Candle';
import { ChartDayLines } from './newCandleChart/ChartDayLines';
import { candleNumberProcessor } from './newCandleChart/utils/candleNumberProcessor';

const MIN_VISIBLE_BODY_HEIGHT = 2;

function buildVisibleBody(scaleY, open, close) {
  const top = scaleY(Math.max(open, close));
  const bottom = scaleY(Math.min(open, close));
  const rawHeight = bottom - top;
  if (rawHeight >= MIN_VISIBLE_BODY_HEIGHT) {
    return {
      rectHeight: rawHeight,
      rectYPos: top,
    };
  }
  return {
    rectHeight: MIN_VISIBLE_BODY_HEIGHT,
    rectYPos: top - MIN_VISIBLE_BODY_HEIGHT / 2,
  };
}

export const OldCandles = ({
  oldCandles,
  caliber,
  scaleX,
  scaleY,
  loading,
  currentZoomState,
  portalRef,
  size,
  showCandleNumbers,
  timeUnit,
  bottomPadding,
}) => {
  const [processedCandles, setProcessedCandles] = useState(null);

  useEffect(() => {
    if (!loading && scaleY !== null && scaleX !== null && caliber !== null) {
      let prevCandle = null;
      const candles = oldCandles.map((candle, index) => {
        const candleNumber = candleNumberProcessor(prevCandle, candle);
        prevCandle = candle;
        const slotIndex = candle.slotIndex ?? index;
        const { rectHeight, rectYPos } = buildVisibleBody(
          scaleY,
          candle.open,
          candle.close
        );
        return {
          zoomMult: currentZoomState === null ? 1 : currentZoomState.k,
          candleNumber,
          rectWidth: caliber,
          rectHeight,
          rectYPos,
          rectXPos: scaleX(slotIndex),
          fill: candle.open < candle.close ? colors.green : colors.red,
          lineHeight: scaleY(candle.low) - scaleY(candle.high),
          lineYPos: scaleY(candle.high),
          lineXPos: scaleX(slotIndex) + caliber / 2,
          timeStamp: candle.timeStamp,
          candleOpen: candle.open,
          candleClose: candle.close,
          candleHigh: candle.high,
          candleLow: candle.low,
        };
      });
      setProcessedCandles(candles);
    }
  }, [oldCandles, caliber, scaleX, scaleY, loading]);

  return (
    <>
      <ChartDayLines
        timeUnit={timeUnit}
        processedCandles={processedCandles}
        size={size}
        bottomPadding={bottomPadding}
      />
      {processedCandles
        ? processedCandles.map((processedCandle) => (
          <Candle
            showCandleNumbers={showCandleNumbers}
            candle={processedCandle}
            key={processedCandle.timeStamp}
            portalRef={portalRef}
            size={size}
            timeUnit={timeUnit}
          />
        ))
        : null}
    </>
  );
};

OldCandles.propTypes = {
  caliber: PropTypes.number,
  currentZoomState: PropTypes.shape({
    k: PropTypes.any,
  }),
  loading: PropTypes.any,
  oldCandles: PropTypes.array,
  portalRef: PropTypes.any,
  scaleBody: PropTypes.func,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  showCandleNumbers: PropTypes.bool,
  timeUnit: PropTypes.string,
  bottomPadding: PropTypes.any,
};
